import { motion } from "framer-motion";

const CHAPTERS = [
    {
        num: "01",
        title: "THE WHITE LINE IS A SACRED TRUST",
        text: "Eighty-thousand pounds of American steel doesn't stop on a dime. We build tools for drivers who command respect on every mile from Portland to Savannah.",
    },
    {
        num: "02",
        title: "NO MORE GUESSING AT CANYON OVERPASSES",
        text: "Generic consumer maps are built for sedans. A 13'6\" box trailer needs precision, clear turning radii, and zero surprise low bridges.",
    },
    {
        num: "03",
        title: "TIME IS DIESEL, DIESEL IS FREEDOM",
        text: "Every minute idling at a closed scale house or hunting for parking burns hard-earned cash. Put your foot in it and let the algorithm clear your path.",
    },
    {
        num: "04",
        title: "ONE DRIVER OR A HUNDRED RIGS",
        text: "Whether you own your sleeper cab or manage a 500-truck interstate fleet, unified telematics and dispatch routing keep your wheels turnin'.",
    },
];

export default function Manifesto() {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative border-y-2 border-[#0E0D0C] bg-[#F6F2E8] px-6 py-24 text-[#161413] lg:px-16 lg:py-32"
        >
            <div className="halftone-bg pointer-events-none absolute inset-0 opacity-[0.12]" />
            <div className="relative mx-auto max-w-7xl">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="flex flex-wrap items-end justify-between gap-6"
                >
                    <div>
                        <p className="font-mono2 text-xs font-bold tracking-[0.35em] text-[#D32F2F]">
                            FILED UNDER: OPEN ROAD DOCTRINE
                        </p>
                        <h2 className="font-display mt-4 text-4xl uppercase tracking-wide sm:text-5xl md:text-6xl">
                            THE OPEN-ROAD <span className="text-[#0055A5]">MANIFESTO</span>
                        </h2>
                    </div>
                    <div className="font-mono2 rotate-[-2deg] border-2 border-[#161413] bg-[#E5A93C] px-4 py-2 text-[10px] font-bold tracking-[0.25em] shadow-[4px_4px_0px_#161413]">
                        EST. 2026 ★ AMERICAN HIGHWAY DIVISION
                    </div>
                </motion.div>

                <div className="mt-16 grid grid-cols-1 gap-x-16 gap-y-14 md:grid-cols-2">
                    {CHAPTERS.map((c, i) => (
                        <motion.div
                            key={c.num}
                            data-testid={`manifesto-chapter-${i + 1}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
                            className="relative border-t-2 border-[#161413] pt-8"
                        >
                            <span className="font-display pointer-events-none absolute -top-6 right-0 select-none text-8xl text-[#161413]/10">
                                {c.num}
                            </span>
                            <p className="font-mono2 text-xs font-bold tracking-[0.35em] text-[#D32F2F]">
                                CHAPTER {c.num}
                            </p>
                            <h3 className="font-display mt-3 text-3xl uppercase leading-none tracking-wider">
                                {c.title}
                            </h3>
                            <p className="font-type mt-4 max-w-md text-base leading-relaxed text-[#24211E]">
                                {c.text}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
